import React, { useState } from 'react';

import Column from 'components/common/Column';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import Divider from 'components/Divider';
import ModifyContainer from '../ModifyContainer';
import { ProductParamInput } from 'containers/ProductRegist/hooks/types';
import AddressForm from '../AddressForm';
import { ProductKind } from 'types/api';
import { formatInteractionType } from 'utils/formatting';
import { ModifyValue } from '../../hooks/useProductDetaillHooks';

interface AddressContainerIProps {
  isMobile: boolean;
  productParamInput: ProductParamInput;
  modifyValue: ModifyValue;
  setModifyValue: React.Dispatch<React.SetStateAction<ModifyValue>>;
}

const AddressContainer: React.FC<AddressContainerIProps> = props => {
  const { isMobile, productParamInput, modifyValue, setModifyValue } = props;

  const fripInfo = productParamInput.frip;
  const isOffline = productParamInput.kind === ProductKind.OFFLINE;

  const renderLocationVenue = (): JSX.Element => {
    return (
      <React.Fragment>
        {fripInfo.locationsOfVenue.map((item, idx) => {
          return (
            <React.Fragment key={idx}>
              <Row justifyContent="space-between" style={{ width: '100%' }}>
                <Text size="16px" color="#414B56">
                  진행하는 장소
                </Text>
              </Row>
              <AddressForm item={item} />
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  };

  const renderLocationGathering = (): JSX.Element => {
    return (
      <React.Fragment>
        {fripInfo.locationOfGathering ? (
          <React.Fragment>
            <Divider />
            <Row justifyContent="space-between" style={{ width: '100%' }}>
              <Text size="16px" color="#414B56">
                모이는 장소
              </Text>
            </Row>
            <AddressForm item={fripInfo.locationOfGathering} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Divider />
            <Row justifyContent="space-between" style={{ width: '100%' }}>
              <Text size="16px" color="#414B56">
                모이는 장소
              </Text>
            </Row>
            <Text
              color="#46474C"
              size="16px"
              weight={isMobile ? 500 : 400}
              style={{ textAlign: 'center', lineHeight: '22px' }}
            >
              등록한 모이는 장소가 없어요. <br />
              진행 장소와 모이는 장소가 다를 시 <br />
              추가 등록해 주세요.
            </Text>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  const renderAddressForm = () => {
    if (isOffline) {
      return (
        <Column gap="24px">
          {renderLocationVenue()}
          {renderLocationGathering()}
        </Column>
      );
    }

    return (
      <Column align="flex-start">
        <Text color="#414B56" size="16px" weight={500}>
          {formatInteractionType(productParamInput.frip.interactionType)}
        </Text>
      </Column>
    );
  };

  return (
    <ModifyContainer
      title={isOffline ? '장소' : '온라인 진행방법'}
      isSelected={
        !isMobile &&
        (modifyValue.modifyStatus === 'address' ||
          modifyValue.modifyStatus === 'online')
      }
      onClick={() => {
        if (!isOffline) {
          setModifyValue({ ...modifyValue, modifyStatus: 'online' });

          return;
        }

        setModifyValue({ ...modifyValue, modifyStatus: 'address' });
      }}
    >
      {renderAddressForm()}
    </ModifyContainer>
  );
};

export default AddressContainer;
